export const setCookie = (name: string, value: string, days?: number) => {
  let cookieString = `${name}=${value}; path=/`
  if (days !== undefined) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
    cookieString += `; expires=${expires}`
  }
  document.cookie = cookieString
}

export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null

  const nameEQ = `${name}=`
  const ca = document.cookie.split(';')
  for (const cookie of ca) {
    const c = cookie.trim()
    if (c.startsWith(nameEQ)) return c.substring(nameEQ.length, c.length)
  }
  return null
}
